import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import Spin from "../views/Spin.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/spin",
    name: "Spin",
    component: Spin,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
